/* tslint:disable */
/* eslint-disable */
/**
 * Marketplace Api
 * Marketplace Api description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: develop@taykus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PandoraTenantConfiguration } from '../models';
// @ts-ignore
import { Place } from '../models';
// @ts-ignore
import { Places } from '../models';
// @ts-ignore
import { Tenant } from '../models';
/**
 * TenantApi - axios parameter creator
 * @export
 */
export const TenantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all tenants
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTenants: async (start: number, size: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'start' is not null or undefined
            assertParamExists('findAllTenants', 'start', start)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('findAllTenants', 'size', size)
            const localVarPath = `/api/tenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the tenant data by id
         * @param {number} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTenantById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findTenantById', 'id', id)
            const localVarPath = `/api/tenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the tenant data from Pandora
         * @param {string} id The pandora tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTenantByIdFromPandora: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findTenantByIdFromPandora', 'id', id)
            const localVarPath = `/api/tenant/configuration/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all tenants filtering by name or a place
         * @param {string} name The tenant or place name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTenantByNameAndPlaceContaining: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('findTenantByNameAndPlaceContaining', 'name', name)
            const localVarPath = `/api/tenant/place`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all tenants filtering by name
         * @param {string} name The tenant name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTenantByNameContaining: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('findTenantByNameContaining', 'name', name)
            const localVarPath = `/api/tenant/name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the tenant data by pandora id
         * @param {string} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTenantByPandoraId: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findTenantByPandoraId', 'id', id)
            const localVarPath = `/api/tenant/pandora/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the tenant data by crm tenant id
         * @param {string} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTenantByTenantId: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findTenantByTenantId', 'id', id)
            const localVarPath = `/api/tenant/crm/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get data about a place
         * @param {string} id The place id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaceDetails: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPlaceDetails', 'id', id)
            const localVarPath = `/api/tenant/place/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantApi - functional programming interface
 * @export
 */
export const TenantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all tenants
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllTenants(start: number, size: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Tenant>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllTenants(start, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the tenant data by id
         * @param {number} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findTenantById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tenant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findTenantById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the tenant data from Pandora
         * @param {string} id The pandora tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findTenantByIdFromPandora(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PandoraTenantConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findTenantByIdFromPandora(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all tenants filtering by name or a place
         * @param {string} name The tenant or place name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findTenantByNameAndPlaceContaining(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Places>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findTenantByNameAndPlaceContaining(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all tenants filtering by name
         * @param {string} name The tenant name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findTenantByNameContaining(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Tenant>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findTenantByNameContaining(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the tenant data by pandora id
         * @param {string} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findTenantByPandoraId(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tenant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findTenantByPandoraId(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the tenant data by crm tenant id
         * @param {string} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findTenantByTenantId(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tenant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findTenantByTenantId(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get data about a place
         * @param {string} id The place id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlaceDetails(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Place>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlaceDetails(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenantApi - factory interface
 * @export
 */
export const TenantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all tenants
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTenants(start: number, size: number, options?: any): AxiosPromise<Array<Tenant>> {
            return localVarFp.findAllTenants(start, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the tenant data by id
         * @param {number} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTenantById(id: number, options?: any): AxiosPromise<Tenant> {
            return localVarFp.findTenantById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the tenant data from Pandora
         * @param {string} id The pandora tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTenantByIdFromPandora(id: string, options?: any): AxiosPromise<PandoraTenantConfiguration> {
            return localVarFp.findTenantByIdFromPandora(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all tenants filtering by name or a place
         * @param {string} name The tenant or place name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTenantByNameAndPlaceContaining(name: string, options?: any): AxiosPromise<Places> {
            return localVarFp.findTenantByNameAndPlaceContaining(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all tenants filtering by name
         * @param {string} name The tenant name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTenantByNameContaining(name: string, options?: any): AxiosPromise<Array<Tenant>> {
            return localVarFp.findTenantByNameContaining(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the tenant data by pandora id
         * @param {string} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTenantByPandoraId(id: string, options?: any): AxiosPromise<Tenant> {
            return localVarFp.findTenantByPandoraId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the tenant data by crm tenant id
         * @param {string} id The tenant id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTenantByTenantId(id: string, options?: any): AxiosPromise<Tenant> {
            return localVarFp.findTenantByTenantId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get data about a place
         * @param {string} id The place id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaceDetails(id: string, options?: any): AxiosPromise<Place> {
            return localVarFp.getPlaceDetails(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantApi - object-oriented interface
 * @export
 * @class TenantApi
 * @extends {BaseAPI}
 */
export class TenantApi extends BaseAPI {
    /**
     * 
     * @summary Get all tenants
     * @param {number} start Zero-based page index
     * @param {number} size The page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public findAllTenants(start: number, size: number, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).findAllTenants(start, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the tenant data by id
     * @param {number} id The tenant id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public findTenantById(id: number, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).findTenantById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the tenant data from Pandora
     * @param {string} id The pandora tenant id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public findTenantByIdFromPandora(id: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).findTenantByIdFromPandora(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all tenants filtering by name or a place
     * @param {string} name The tenant or place name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public findTenantByNameAndPlaceContaining(name: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).findTenantByNameAndPlaceContaining(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all tenants filtering by name
     * @param {string} name The tenant name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public findTenantByNameContaining(name: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).findTenantByNameContaining(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the tenant data by pandora id
     * @param {string} id The tenant id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public findTenantByPandoraId(id: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).findTenantByPandoraId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the tenant data by crm tenant id
     * @param {string} id The tenant id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public findTenantByTenantId(id: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).findTenantByTenantId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get data about a place
     * @param {string} id The place id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public getPlaceDetails(id: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).getPlaceDetails(id, options).then((request) => request(this.axios, this.basePath));
    }
}
